import { render, staticRenderFns } from "./template.html?vue&type=template&id=56c02a50&"
import script from "./HomeFavoritelistItem.vue?vue&type=script&lang=ts&"
export * from "./HomeFavoritelistItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports